import { ReactElement, useMemo, useState } from 'react';
import { onImageError } from '@helper/utils';
import { IMeetingMediaPreviewProps } from '@components/meeting-details';
import NoVideoImage from '@assets/images/videoNotAvailable.png';

const isVideoUrl = (url: string): boolean => /\.(webp|mp4|webm|ogg|mov)$/i.test(url.split('?')[0]);

const isMovUrl = (url: string): boolean => /\.mov$/i.test(url.split('?')[0]);

export const MeetingMediaPreview = ({ uploadedImageUrls = [] }: IMeetingMediaPreviewProps): ReactElement => {
	const [failedVideos, setFailedVideos] = useState<Record<string, boolean>>({});

	const handleVideoError = (url: string): void => {
		setFailedVideos((prev) => ({ ...prev, [url]: true }));
	};

	const renderedMedia = useMemo(() => {
		return uploadedImageUrls
			.filter((url): url is string => Boolean(url))
			.map((url) => {
				const isVideo = isVideoUrl(url);
				const videoFailed = failedVideos[url];
				const isMov = isMovUrl(url);

				return (
					<div key={url} className="upload-image">
						<div className="wrapper-upload-images">
							<a href={url} target="_blank" rel="noopener noreferrer">
								{isVideo ? (
									videoFailed ? (
										<div className="video-fallback">
											<img src={NoVideoImage} alt="video not available" className="media-preview" />
										</div>
									) : (
										<video
											src={`${url}#t=0.001`}
											className="media-preview"
											muted
											playsInline
											preload="metadata"
											onError={() => handleVideoError(url)}
										>
											{isMov && <source src={url} type="video/mp4" />}
											<track kind="captions" />
										</video>
									)
								) : (
									<img
										role="presentation"
										src={url}
										alt="meeting-media"
										title="meeting"
										onError={onImageError}
										className="media-preview"
									/>
								)}
							</a>
						</div>
					</div>
				);
			});
	}, [uploadedImageUrls, failedVideos]);

	return (
		<li className="d-col d-col-2 site-product-images-wrapper">
			<div className="upload-images-wrapper">{renderedMedia}</div>
		</li>
	);
};
